import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BBAnswerType, EmployeeStatus, QuestionLocationType, PAYMENT_TYPES } from '@whitbread-eos/api';
import sanitizeHtml from 'sanitize-html';
import { isPIBACardType } from '../validators/index';
export var ParseDateToYMD = date => {
  if (!date) {
    return;
  }
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  return "".concat(year, "-").concat(month, "-").concat(day);
};
export var parseRegistrationQuestions = rawQuestions => {
  var _rawQuestions$userDef, _rawQuestions$userDef2;
  var questionsArray = [];
  var fillQuestionObject = (id, mandatory, type, options, answer, label, key) => {
    return {
      id: key !== null && key !== void 0 ? key : id,
      mandatory,
      type: type === BBAnswerType.U ? 'select' : 'text',
      options,
      answer: answer !== null && answer !== void 0 ? answer : '',
      label
    };
  };
  if (rawQuestions !== null && rawQuestions !== void 0 && rawQuestions.purchaseOrderManagement && rawQuestions !== null && rawQuestions !== void 0 && rawQuestions.purchaseOrderManagement.active && (rawQuestions === null || rawQuestions === void 0 ? void 0 : rawQuestions.purchaseOrderManagement.location) === QuestionLocationType.R) {
    var _rawQuestions$purchas, _rawQuestions$purchas2;
    questionsArray.push(fillQuestionObject(rawQuestions.purchaseOrderManagement.questionId, rawQuestions.purchaseOrderManagement.mandatory, (_rawQuestions$purchas = rawQuestions.purchaseOrderManagement.managementInformationAnswer) === null || _rawQuestions$purchas === void 0 ? void 0 : _rawQuestions$purchas.answerType, (_rawQuestions$purchas2 = rawQuestions.purchaseOrderManagement.managementInformationAnswer) === null || _rawQuestions$purchas2 === void 0 ? void 0 : _rawQuestions$purchas2.answers, rawQuestions.purchaseOrderManagement.answer, rawQuestions.purchaseOrderManagement.label, 'purchaseOrderAnswer'));
  }
  if (rawQuestions !== null && rawQuestions !== void 0 && rawQuestions.customerReferenceManagement && rawQuestions !== null && rawQuestions !== void 0 && rawQuestions.customerReferenceManagement.active && (rawQuestions === null || rawQuestions === void 0 ? void 0 : rawQuestions.customerReferenceManagement.location) === QuestionLocationType.R) {
    var _rawQuestions$custome, _rawQuestions$custome2;
    questionsArray.push(fillQuestionObject(rawQuestions.customerReferenceManagement.questionId, rawQuestions.customerReferenceManagement.mandatory, (_rawQuestions$custome = rawQuestions.customerReferenceManagement.managementInformationAnswer) === null || _rawQuestions$custome === void 0 ? void 0 : _rawQuestions$custome.answerType, (_rawQuestions$custome2 = rawQuestions.customerReferenceManagement.managementInformationAnswer) === null || _rawQuestions$custome2 === void 0 ? void 0 : _rawQuestions$custome2.answers, rawQuestions.customerReferenceManagement.answer, rawQuestions.customerReferenceManagement.label, 'customerReferenceAnswer'));
  }
  if (rawQuestions !== null && rawQuestions !== void 0 && (_rawQuestions$userDef = rawQuestions.userDefinedQuestions) !== null && _rawQuestions$userDef !== void 0 && _rawQuestions$userDef.length && (rawQuestions === null || rawQuestions === void 0 ? void 0 : rawQuestions.userDefinedQuestions[0]) !== null) {
    rawQuestions.userDefinedQuestions.map(question => {
      if ((question === null || question === void 0 ? void 0 : question.location) === QuestionLocationType.R) {
        var _question$questionId, _question$managementI, _question$managementI2;
        questionsArray.push(fillQuestionObject((_question$questionId = question.questionId) !== null && _question$questionId !== void 0 ? _question$questionId : '', question.mandatory, (_question$managementI = (_question$managementI2 = question.managementInformationAnswer) === null || _question$managementI2 === void 0 ? void 0 : _question$managementI2.answerType) !== null && _question$managementI !== void 0 ? _question$managementI : BBAnswerType.F, question.managementInformationAnswer.answers, question.userDefinedAnswer, question.label));
      }
    });
  }
  if (rawQuestions !== null && rawQuestions !== void 0 && (_rawQuestions$userDef2 = rawQuestions.userDefinedManagement) !== null && _rawQuestions$userDef2 !== void 0 && _rawQuestions$userDef2.length && (rawQuestions === null || rawQuestions === void 0 ? void 0 : rawQuestions.userDefinedManagement[0]) !== null) {
    rawQuestions.userDefinedManagement.map(question => {
      if ((question === null || question === void 0 ? void 0 : question.location) === QuestionLocationType.R) {
        var _question$questionId2, _question$managementI3, _question$managementI4;
        questionsArray.push(fillQuestionObject((_question$questionId2 = question.questionId) !== null && _question$questionId2 !== void 0 ? _question$questionId2 : '', question.mandatory, (_question$managementI3 = (_question$managementI4 = question.managementInformationAnswer) === null || _question$managementI4 === void 0 ? void 0 : _question$managementI4.answerType) !== null && _question$managementI3 !== void 0 ? _question$managementI3 : BBAnswerType.F, question.managementInformationAnswer.answers, question.userDefinedAnswer, question.label));
      }
    });
  }
  return questionsArray;
};
export function formatIBAssetsUrl() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var checkedPath = path.includes('/') ? path : '/';
  return "https://".concat(process.env.NEXT_PUBLIC_ASSETS_URL).concat(checkedPath);
}
export function formatHDPUrl(redirectURL) {
  if (!redirectURL || redirectURL.indexOf('&') === -1) {
    return redirectURL;
  }
  var checkNoOfPairs = redirectURL.match(/&/g) || [];
  var checkNoOfParams = redirectURL.match(/=/g) || [];
  if ((checkNoOfPairs === null || checkNoOfPairs === void 0 ? void 0 : checkNoOfPairs.length) === 0 || (checkNoOfParams === null || checkNoOfParams === void 0 ? void 0 : checkNoOfParams.length) !== (checkNoOfPairs === null || checkNoOfPairs === void 0 ? void 0 : checkNoOfPairs.length) + 1) {
    return redirectURL;
  }
  return redirectURL.split('&').map(kvPair => {
    if (kvPair.indexOf('ARRdd') > -1 || kvPair.indexOf('ARRmm') > -1) {
      var _kvPair$split = kvPair.split('='),
        _kvPair$split2 = _slicedToArray(_kvPair$split, 2),
        key = _kvPair$split2[0],
        value = _kvPair$split2[1];
      return "".concat(key, "=").concat(('0' + value).slice(-2));
    }
    return kvPair;
  }).join('&');
}
export var capitalizeFirstLetter = input => {
  var lowerCase = input.toLowerCase();
  return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1);
};
export function getLabelType(status) {
  var isEmployeeStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  switch (status) {
    case EmployeeStatus.Active:
      return isEmployeeStatus ? 'userMgmt.account.status.active' : 'userMgmt.manageEmployees.seachresults.status.active';
    case EmployeeStatus.Inactive:
      return isEmployeeStatus ? 'userMgmt.account.status.inactive' : 'userMgmt.manageEmployees.seachresults.status.inactive';
    case EmployeeStatus.Suspended:
    case EmployeeStatus.Purged:
    case EmployeeStatus.Deactivated:
      return isEmployeeStatus ? 'userMgmt.account.status.deactivated' : 'userMgmt.manageEmployees.seachresults.status.deactivated';
    default:
      return '';
  }
}
export function getStyling(status) {
  switch (status) {
    case EmployeeStatus.Active:
      return 'bg-success';
    case EmployeeStatus.Inactive:
      return 'bg-warning';
    case EmployeeStatus.Suspended:
    case EmployeeStatus.Purged:
    case EmployeeStatus.Deactivated:
      return 'bg-error';
    default:
      return '';
  }
}
export function resolveAndDownloadBlob(response, name, format) {
  var filename = "".concat(name).concat(format);
  filename = decodeURI(filename);
  var url = window.URL.createObjectURL(new Blob([response]));
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
}
export function formatAccountNumber(accountNumber) {
  return accountNumber ? accountNumber.replace(/(\d{4})(?=\d)/g, '$1 ') : '';
}
var switchStateMapping = {
  premierInnBreakfast: ['11'],
  continentalBreakfast: ['12'],
  freeChildBreakfast: ['15'],
  mealDeal: ['17'],
  hubBreakfast: ['18'],
  ultimateWifi: ['135', '136', '137']
};
export var mapSwitchState = switchState => {
  var upsellItemsAllowed = [];
  Object.entries(switchState).forEach(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (value) {
      upsellItemsAllowed.push(...(switchStateMapping[key] || []));
    }
  });
  return upsellItemsAllowed;
};
export var getDefaultSwitchState = upsellItemsAllowed => {
  var defaultState = {
    premierInnBreakfast: false,
    continentalBreakfast: false,
    mealDeal: false,
    hubBreakfast: false,
    ultimateWifi: false
  };
  Object.entries(switchStateMapping).forEach(_ref3 => {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      values = _ref4[1];
    if (values.some(value => upsellItemsAllowed.includes(value))) {
      defaultState[key] = true;
    }
  });
  return defaultState;
};
export var getVariant = (field, variant) => variant ? "".concat(variant, ".").concat(field) : field;
export function normalizeAddress(address) {
  return Object.fromEntries(Object.entries(address).map(_ref5 => {
    var _ref6 = _slicedToArray(_ref5, 2),
      key = _ref6[0],
      value = _ref6[1];
    return [key, value === null ? '' : value];
  }));
}
export function findError(path, obj) {
  var _current;
  if (!obj || Object.keys(obj).length === 0) {
    return undefined;
  }
  var keys = path.split('.');
  var current = obj;
  for (var key of keys) {
    if (current[key] === undefined) {
      return undefined;
    }
    current = current[key];
  }
  return (_current = current) === null || _current === void 0 ? void 0 : _current.message;
}
export var getSavedCardType = function getSavedCardType() {
  var cardType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!cardType) return undefined;
  return isPIBACardType(cardType) ? PAYMENT_TYPES.KEEP_PIBA : PAYMENT_TYPES.KEEP_CARD;
};
export var sanitize = html => {
  return sanitizeHtml(html, {
    allowedTags: [],
    allowedAttributes: {}
  });
};
var parseUserDefinedAnswer = (data, key) => {
  var _data$key;
  return typeof data[key] === 'string' ? data[key] : (_data$key = data[key]) === null || _data$key === void 0 ? void 0 : _data$key.value;
};
export var parseAnswersObj = (data, excludeKeys) => {
  var answersObj = {
    userDefinedAnswers: Object.keys(data).filter(key => !(excludeKeys !== null && excludeKeys !== void 0 && excludeKeys.includes(key))).map(key => ({
      miID: key,
      miAnswer: parseUserDefinedAnswer(data, key)
    }))
  };
  if ('customerReferenceAnswer' in data) {
    answersObj.customerReferenceAnswer = data.customerReferenceAnswer;
  }
  if ('purchaseOrderAnswer' in data) {
    answersObj.purchaseOrderAnswer = data.purchaseOrderAnswer;
  }
  return answersObj;
};